import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step17View from './Step17-view';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step17 = ({regType, submitStep}) => {
  const {formatMessage} = useIntl();

  const handleSubmit = () => {
    submitStep({
      step: 17,
      data: {regType},
    })
      .then(checkNextStepAndGo)
      .then(() => trackEvent('signup_step',
          {
            step_number: 17,
            step_name_en: 'Just before the end',
            step_name_he: formatMessage({id: 'step17.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  return (
    <Formik
      initialValues={{}}
      onSubmit={handleSubmit}
      validateOnChange={true}
      validateOnBlur={false}
    >
      <Step17View/>
    </Formik>
  )
};

Step17.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  submitStep: PropTypes.func
};

export default Step17;
